<template>
  <div>
    <simple-header
      :header="$root.content.header"
    />
    <!-- <header-dallym-art /> -->

    <section class="wrapper__entries">
      <div
        v-if="partsToUse"
        v-for="(part, i) in partsToUse"
        :key="`entry-${i}`"
        class="entry"
        :style="{
          opacity: (i === activeIndex) ? 1 : typeof activeIndex !== 'number' ? 1 : 0.6,
        }"
        @click="toggle(i)"
      >

        <item-top-slot
          :active="(i === activeIndex) ? true : typeof activeIndex !== 'number' ? true : false"
          :style="{
            transition: 'transform 300ms',
            transform: `scale(${(i === activeIndex) ? 1 : typeof activeIndex !== 'number' ? 1 : 0.9})`,
          }"
        >
          <team-top
            :content="part"
            :active="isActive(i)"
            :barrier="barriers ? barriers[i].barrier : null"
          />
        </item-top-slot>

        <div
          class="wrapper__bottom"
          :style="{
            transition: i == activeIndex ? '' : 'height 400ms',
            height: i === activeIndex ? `${openHeight}px` : '0px'
          }"
        >
          <item-bottom-slot
            :active="i === activeIndex"
            @bottomHeight="setOpenHeight"
          >
            <team-bottom :content="part" />
          </item-bottom-slot>
        </div>
      </div>
    </section>
  </div>

</template>


<script>
// import smoothscroll from 'smoothscroll-polyfill'

import SimpleHeader from '@/components/headers/simple-title.vue'
// import HeaderDallymArt from '@/components/headers/header-dallym-art.vue'
import ItemTopSlot from '@/components/expanding-grid/item-top-slot.vue'
import ItemBottomSlot from '@/components/expanding-grid/item-bottom-slot.vue'

// import TeamTop from '@/components/dally-m/team-top.vue'
import TeamTop from '@/components/dally-m/games-top.vue'
import TeamBottom from '@/components/dally-m/team-bottom.vue'

export default {
  name: 'expandinggrid-dallym-teams',
  props: [],
  components: {
    ItemTopSlot,
    ItemBottomSlot,
    SimpleHeader,
    // HeaderDallymArt,

    TeamTop,
    TeamBottom,
  },
  data () {
    return {
      options: this.$root.content.options,
      activeIndex: null,
      openHeight: 0,
      heightTarget: 0,
      heightDirection: 'grow',
      heightDifference: 0,
      heightTick: 0,
      shouldClose: false,
      partsToUse: null,
      barriers: null,
      loadCount: 0,
    }
  },
  methods: {
    isActive (i) {
      if (typeof this.activeIndex !== 'number') return false
      if (i === this.activeIndex) return true
      return false
    },
    // updateSort (val) {
    //   if (val === this.activeSort.value) {
    //     this.activeSort.ascend = !this.activeSort.ascend
    //   } else {
    //     this.activeSort.value = val
    //   }
    //   this.updatePartsToUse()
    // },
    // updateFilter (filter) {
    //   this.activeIndex = null
    //   this.activeFilter[filter.category].value = filter.value
    //   // Imnvestigate lifecycle hooks
    //   // ? Not tearing down components correctly when removed?
    //   this.updatePartsToUse()
    // },
    toggle (i) {
      if (i === this.activeIndex) {
        this.setOpenHeight(0)
        this.activeIndex = null
        return
      }
      this.activeIndex = i
      ga('send', 'event', {
        hitType: 'event', 
        eventAction: 'click',
        eventCategory: this.$root.content.id,
        eventLabel: this.$root.content.parts[i].name,
      })
    },
    setOpenHeight (height) {
      this.heightTarget = height
      this.heightDifference = height - this.openHeight
      this.heightDirection = height >= this.openHeight ? 'grow' : 'shrink'
      this.heightTick = this.heightDifference / 10
      window.requestAnimationFrame(this.updateOpenHeight)
    },
    updateOpenHeight () {
      this.openHeight += this.heightTick
      if (this.heightDirection === 'grow') {
        if (this.openHeight <= this.heightTarget) {
          window.requestAnimationFrame(this.updateOpenHeight)
        } else {
          this.openHeight = this.heightTarget
        }
      } else {
        if (this.openHeight >= this.heightTarget) {
          window.requestAnimationFrame(this.updateOpenHeight)
        } else {
          this.openHeight = this.heightTarget
        }
      }
    },

    // clearPartsToUse () {
    //   this.partsToUse = null
    //   this.activeIndex = null
    // },
    loadBarriers () {
      this.loadCount++
      if (window.__everest_barriers) {
        this.barriers = window.__everest_barriers
      } else if (this.loadCount < 50) {
        setTimeout(this.loadBarriers, 200)
      }
    },
    storePartsToUse () {
      this.partsToUse = this.$root.content.parts
        .sort((sortA, sortB) => {
          const a = sortA.tab // this.sortBy(sortA.tab)
          const b = sortB.tab // this.sortBy(sortB.tab)
          if (a > b) return 1 // return this.activeSort.ascend ? 1 : -1
          if (a < b) return -1 // return this.activeSort.ascend ? -1 : 1
          return 0
        })
        // .filter(p => {
        //   const output = Object.keys(this.activeFilter).map(k => {
        //     const { match, value } = this.activeFilter[k]
        //     if (value.toLowerCase() === 'all') return true
        //     if (match === 'range') {
        //       const range = value.split(',')
        //       const checkAgainst = parseInt(p[k].replace('$', '').trim(), 10)
        //       return (checkAgainst >= parseInt(range[0], 10)) && (checkAgainst <= parseInt(range[1], 10))
        //     }
        //     return p[k].toLowerCase() === value.toLowerCase()
        //   })
        //   return output.every(t => t)
        // })
    },
    // sortBy (word) {
    //   if (typeof word === 'number') return word
    //   return word
    //     .trim()
    //     .toLowerCase()
    //     .split(' ')
    //     .filter(w => !this.sortIgnore.includes(w))
    //     .slice(-1)[0]
    // },
    // updatePartsToUse () {
    //   this.clearPartsToUse()
    //   setTimeout(this.storePartsToUse, 50)
    // },

  },
  computed: {},
  mounted () {
    this.$nextTick(() => {
      this.storePartsToUse()
      this.loadBarriers()
      // smoothscroll.polyfill()
      // this.$root.content.options.filters.forEach(filter => {
      //   this.activeFilter[filter.category] = {
      //     value: filter.default,
      //     match: filter.match,
      //   }
      // })
      // this.updatePartsToUse()
    })
  }
}
</script>


<style scoped lang="sass">
@import index

[data-longform=true]
  .wrapper__entries
    width: 95vw

.wrapper
  &__entries
    display: flex
    flex-wrap: wrap
    justify-content: center
    max-width: 1100px
    background: white
    left: 50%
    transform: translate(-50%, 0)
  &__items
    position: relative
    width: 100%
    text-align: center
    margin-bottom: 12px
  &__bottom
    position: initial
    overflow: hidden

.entry
  transition: opacity 600ms
  position: initial
  min-width: 250px
  width: 30%
  max-width: 500px
  flex: 1 1 auto
  margin-bottom: 2px
  &__bottom
    position: absolute
    width: 100%
    left: 0

</style>



// WEBPACK FOOTER //
// src/layouts/expandinggrid-dallym-teams.vue